import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import PublicCatalog from "@/pages/PublicCatalog";
import Dashboard from "@/pages/Dashboard";
import Sales from "@/pages/Sales";
import SaleForm from "@/pages/SaleForm";
import SaleDetail from "@/pages/SaleDetail";
import Overdue from "@/pages/Overdue";
import Payments from "@/pages/Payments";
import Purchases from "@/pages/Purchases";
import PurchaseDetail from "@/pages/PurchaseDetail";
import Customers from "@/pages/Customers";
import Cars from "@/pages/Cars";
import InterestRates from "@/pages/InterestRates";
import LateCategories from "@/pages/LateCategories";
import Catalog from "@/pages/Catalog";
import Calculator from "@/pages/Calculator";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Import from "@/pages/Import";
import AuditBackup from "@/pages/AuditBackup";
import Commission from "@/pages/Commission";
import CashBook from "@/pages/CashBook";
import Reports from "@/pages/Reports";
import PnL from "@/pages/PnL";
import ResetData from "@/pages/ResetData";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<PublicCatalog />} />
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/sales/new" element={<SaleForm />} />
              <Route path="/purchases" element={<Purchases />} />
              <Route path="/purchases/:id" element={<PurchaseDetail />} />
              <Route path="/sales/:id" element={<SaleDetail />} />
              <Route path="/overdue" element={<Overdue />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/cars" element={<Cars />} />
              <Route path="/interest-rates" element={<InterestRates />} />
              <Route path="/late-categories" element={<LateCategories />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/users" element={<Users />} />
              <Route path="/import" element={<Import />} />
              <Route path="/audit" element={<AuditBackup />} />
              <Route path="/commission" element={<Commission />} />
              <Route path="/cashbook" element={<CashBook />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/reports/pnl" element={<PnL />} />
              <Route path="/reports/sales" element={<Cars />} />
              <Route path="/reports/purchases" element={<Purchases />} />
              <Route path="/reset-data" element={<ResetData />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
